import React from 'react';
import ReactModal from 'react-modal';
import PropTypes from 'prop-types';
import {CloseButton} from '@learningblocks/storybook-components';
import './style.scss';

ReactModal.setAppElement('#root');

/**
 * Modal Component: The component to handle model windows in project
 *  - This component use 'react-modal' package as it base.
 */
export function Modal(props) {
  const renderCloseButton = () => {
    if (props.closeButton) {
      return <CloseButton size={props.size} close={props.close} />;
    } else {
      return null;
    }
  };

  const setModalClassName = () => `${props.className} ${props.size}`;

  return (
    <ReactModal
      className={setModalClassName()}
      isOpen={props.isOpen}
      contentLabel={props.contentLabel}
      onRequestClose={props.close}
      shouldCloseOnOverlayClick={props.closeOnOverlayClick}>
      {renderCloseButton()}
      {props.children}
    </ReactModal>
  );
}

Modal.propTypes = {
  /**
   * Boolean value to handle modal open/close
   */
  isOpen: PropTypes.bool.isRequired,
  /**
   * Callback function to execute when modal is to be closed
   */
  close: PropTypes.func,
  /**
   * String to be displayed as the title for Modal
   */
  contentLabel: PropTypes.string,
  /**
   * React component to be displayed in the modal
   */
  children: PropTypes.element,
  /**
   * Boolean value to specify if we should close the modal if clicked on overlay
   */
  closeOnOverlayClick: PropTypes.bool,
  /**
   * String to be set as className for the modal
   */
  className: PropTypes.string,
  /**
   * Boolean value  that specify if we should display the close button.
   */
  closeButton: PropTypes.bool,
  /**
   * String value specifying the size of modal window ['sm','md','lg']
   */
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
};

Modal.defaultProps = {
  isOpen: false,
  contentLabel: '',
  closeOnOverlayClick: false,
  className: '',
  closeButton: false,
  size: 'sm',
};
